import React from 'react'

import { ButtonClean } from '@fourthwall/components'

import { useCustomizationV4Query } from '../../hooks/useCustomizationV4Query'
import { useProductBySlugQuery } from '../../hooks/useProductBySlugQuery'
import useDownloadZip from './useDownloadZip'

type DesignEditButtonProps = {
  customizationId: string
}

export const DownloadArtFilesButton = ({ customizationId }: DesignEditButtonProps) => {
  const { downloadZip, isProcessing } = useDownloadZip(customizationId)

  const { customizationV4Query } = useCustomizationV4Query([customizationId])
  const { productBySlugQuery } = useProductBySlugQuery(
    [customizationV4Query.data?.product.slug!!],
    {
      enabled: !!customizationV4Query.data?.product.slug,
    },
  )

  if (!customizationV4Query.data || !productBySlugQuery.data) {
    return null
  }

  if (productBySlugQuery.data.customizationType === 'REQUESTABLE') {
    return null
  }

  return (
    <ButtonClean
      label={isProcessing ? 'Downloading...' : 'Download art files'}
      disabled={isProcessing}
      onClick={async () => {
        await downloadZip()
      }}
    />
  )
}
